import '@vebox/etui-system';
import '../../utilities/omit.js';
import { Children, isValidElement } from 'react';
import { a as _objectSpread2, _ as _objectWithoutProperties } from '../../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../../Td-2423cb3a.js';
import createTableRow from '../createBodyRow.js';
import createHeaderCell from '../createHeaderCell.js';
import 'react-resizable';
import createBodyCell from '../createBodyCell.js';

const _excluded = ["header", "body"];
function flatArray(data = [], childrenName = 'children') {
  const result = [];
  const loop = array => {
    array.forEach(item => {
      if (item[childrenName]) {
        const newItem = _objectSpread2({}, item);
        delete newItem[childrenName];
        result.push(newItem);
        if (item[childrenName].length > 0) {
          loop(item[childrenName]);
        }
      } else {
        result.push(item);
      }
    });
  };
  loop(data);
  return result;
}
function treeMap(tree, mapper, childrenName = 'children') {
  return tree.map((node, index) => {
    const extra = {};
    if (node[childrenName]) {
      extra[childrenName] = treeMap(node[childrenName], mapper, childrenName);
    }
    return _objectSpread2(_objectSpread2({}, mapper(node, index)), extra);
  });
}
function flatFilter(tree, callback) {
  return tree.reduce((acc, node) => {
    if (callback(node)) {
      acc.push(node);
    }
    if (node.children) {
      const children = flatFilter(node.children, callback);
      acc.push(...children);
    }
    return acc;
  }, []);
}
function normalizeColumns(elements) {
  const columns = [];
  Children.forEach(elements, element => {
    if (! /*#__PURE__*/isValidElement(element)) {
      return;
    }
    const column = _objectSpread2({}, element.props);
    if (element.key) {
      column.key = element.key;
    }
    if (element.type && element.type) {
      column.children = normalizeColumns(column.children);
    }
    columns.push(column);
  });
  return columns;
}
function stopPropagation(e) {
  e.stopPropagation();
  if (e.nativeEvent.stopImmediatePropagation) {
    e.nativeEvent.stopImmediatePropagation();
  }
}
function shallowEqual(objA, objB, compare, compareContext) {
  let ret = compare ? compare.call(compareContext, objA, objB) : undefined;
  if (ret !== undefined) {
    return !!ret;
  }
  if (objA === objB) {
    return true;
  }
  if (typeof objA !== 'object' || !objA || typeof objB !== 'object' || !objB) {
    return false;
  }
  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) {
    return false;
  }
  const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (let idx = 0; idx < keysA.length; idx++) {
    const key = keysA[idx];
    if (!bHasOwnProperty(key)) {
      return false;
    }
    const valueA = objA[key];
    const valueB = objB[key];
    ret = compare ? compare.call(compareContext, valueA, valueB, key) : undefined;
    if (ret === false || ret === undefined && valueA !== valueB) {
      return false;
    }
  }
  return true;
}
function isSameColumn(a, b) {
  if (a && b && a.key && a.key === b.key) {
    return true;
  }
  return a === b ||
  // @ts-ignore
  // eslint-disable-next-line consistent-return
  shallowEqual(a, b, (value, other) => {
    if (typeof value === 'function' && typeof other === 'function') {
      return value === other || value.toString() === other.toString();
    }
  });
}
function getRowSelection(props) {
  return props.rowSelection || {};
}
const getCurrentBreakpoint = (width, theme) => {
  const {
    breakpoints
  } = theme;
  const xsWidth = parseInt(breakpoints[0], 10);
  const smWidth = parseInt(breakpoints[1], 10);
  const mdWidth = parseInt(breakpoints[2], 10);
  if (width <= xsWidth) {
    return 'xs';
  }
  if (width > xsWidth && width <= smWidth) {
    return 'sm';
  }
  if (width > smWidth && width <= mdWidth) {
    return 'md';
  }
  return 'lg';
};
function createComponents(components = {}, styles = {}) {
  const {
      header,
      body
    } = components,
    rest = _objectWithoutProperties(components, _excluded);
  return _objectSpread2(_objectSpread2({}, rest), {}, {
    header: header || _objectSpread2(_objectSpread2({}, header), {}, {
      cell: createHeaderCell(styles.th)
    }),
    body: body && typeof body === 'function' ? body : _objectSpread2(_objectSpread2({}, body), {}, {
      row: createTableRow(),
      cell: createBodyCell(styles.td)
    })
  });
}
function isTheSameComponents(components1 = {}, components2 = {}) {
  return components1 === components2 || ['table', 'header', 'body'].every(key => shallowEqual(components1[key], components2[key]));
}
const updateResizableColumnWidth = (propColumns, stateColumns) => {
  return propColumns.map((column, idx) => _objectSpread2(_objectSpread2({}, column), {}, {
    width: stateColumns[idx].width
  }));
};
const hasResizableColumns = columns => {
  return columns.some(column => {
    var _column$onHeaderCell;
    const headerCellProps = (column === null || column === void 0 ? void 0 : (_column$onHeaderCell = column.onHeaderCell) === null || _column$onHeaderCell === void 0 ? void 0 : _column$onHeaderCell.call(column, column)) || {};
    return headerCellProps.isResizable;
  });
};

export { createComponents, flatArray, flatFilter, getCurrentBreakpoint, getRowSelection, hasResizableColumns, isSameColumn, isTheSameComponents, normalizeColumns, stopPropagation, treeMap, updateResizableColumnWidth };
